import { render, staticRenderFns } from "./zixun2.vue?vue&type=template&id=41fa56fc&scoped=true&"
import script from "./zixun2.vue?vue&type=script&lang=js&"
export * from "./zixun2.vue?vue&type=script&lang=js&"
import style0 from "./zixun2.vue?vue&type=style&index=0&id=41fa56fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fa56fc",
  null
  
)

export default component.exports